import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api.constants';
import { ApiResponse } from '../interfaces/api-response.model';
import {
  BusinessConfirmAppointmentRequest,
  ConfirmAppointmentRequest,
  ConfirmAppointmentResponse,
} from '../interfaces/appointment-confirm.model';

/**
 * 檢查預約資料服務
 */
@Injectable({
  providedIn: 'root',
})
export class AppointmentConfirmService {
  http: HttpClient = inject(HttpClient);

  /**
   * 送出資料進行預約
   * @param request 預約請求
   */
  confirmAppointment(
    request: ConfirmAppointmentRequest
  ): Observable<ApiResponse<ConfirmAppointmentResponse>> {
    // return this.axiosHttpService.post(API_ENDPOINTS.CONFIRM_APPOINTMENT, request)
    // return this.axiosHttpService.get(API_ENDPOINTS.CONFIRM_APPOINTMENT);
    return this.http.post<ApiResponse<ConfirmAppointmentResponse>>(
      API_ENDPOINTS.CONFIRM_APPOINTMENT,
      request
    );
  }

  /**
   * 企業確認預約
   * @param request 企業確認預約請求
   */
  businessConfirmAppointment(
    request: BusinessConfirmAppointmentRequest
  ): Observable<ApiResponse<ConfirmAppointmentResponse>> {
    return this.http.post<ApiResponse<ConfirmAppointmentResponse>>(
      API_ENDPOINTS.BUSINESS_CONFIRM_APPOINTMENT,
      request
    );
  }
}
